export { ToISODate } from './lib/functions/format-date';
export { NormalizeEmail } from './lib/functions/normalize-email';
export { GetTimeDifference } from './lib/functions/time-difference';
export { ToOrdinalNumber } from './lib/functions/to-ordinal-number';
export { ToPlainText } from './lib/functions/to-plain-text';
